import React from 'react';
import { useSelector } from 'react-redux';

import ThresholdIcon from '@swf/core/assets/icons/warning-triangle.svg';
import SuspendedIcon from '@swf/core/assets/icons/warning.svg';
import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';

import styles from './AMLIcon.scss';

interface Props {
  isOpen: boolean;
  path?: string;
}

const AMLIcon: React.FC<Props> = ({ isOpen, path }) => {
  const amlVerified = useSelector(select.account.amlVerified);
  const amlDepositThresholdReached = useSelector(select.account.amlDepositThresholdReached);
  const amlDocsInProgress = useSelector(select.account.amlDocsInProgress);
  const amlSuspended = useSelector(select.account.amlSuspended);
  const verifyAccountFlag = useFeature(FeatureFlag.VerifyAccount);
  const renderVerifyAccountIcon = () => {
    if (amlDepositThresholdReached && path === '/account/details' && !isOpen) {
      return <ThresholdIcon width="18" height="17" className={styles.titleWarning} />;
    }
    if (amlDepositThresholdReached && path === '/account/details/verify-account') {
      return <ThresholdIcon width="18" height="17" className={styles.itemWarning} />;
    }
    if (amlSuspended && path === '/account/details' && !isOpen) {
      return <SuspendedIcon width="18" height="18" className={styles.titleWarning} />;
    }
    if (amlSuspended && path === '/account/details/verify-account') {
      return <SuspendedIcon width="18" height="18" className={styles.itemWarning} />;
    }

    return null;
  };

  if (verifyAccountFlag && !amlDocsInProgress && !amlVerified) {
    return renderVerifyAccountIcon();
  }

  return null;
};

export default AMLIcon;
